import { render, staticRenderFns } from "./Contactds.vue?vue&type=template&id=a1296904&scoped=true&"
import script from "./Contactds.vue?vue&type=script&lang=js&"
export * from "./Contactds.vue?vue&type=script&lang=js&"
import style0 from "./Contactds.vue?vue&type=style&index=0&id=a1296904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1296904",
  null
  
)

export default component.exports